import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import './BusinessContact.css';

const BusinessContact = (props) => {
  const [formData, setFormData] = useState({
    companyName: '',
    contactPerson: '',
    email: '',
    phone: '',
    industry: '',
    projectNeeds: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = 'Business Onboarding | Global Expedyte';
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Simulate submission - replace with actual API call
    setTimeout(() => {
      console.log('Business inquiry submitted:', formData);
      setSubmitted(true);
      setLoading(false);
    }, 1500);
  };

  if (submitted) {
    return (
      <div className="business-contact-page">
        <Navigation {...props} />
        
        <div className="business-contact-container">
          <div className="success-message">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
                <polyline points="22 4 12 14.01 9 11.01"/>
              </svg>
            </div>
            
            <h1>Thank You for Your Interest!</h1>
            
            <p className="success-text">
              We've received your inquiry and our team will review your information. 
              A member of our business onboarding team will contact you within 24-48 hours 
              to discuss how Global Expedyte can help you find the perfect talent for your projects.
            </p>

            <div className="next-steps">
              <h3>What Happens Next?</h3>
              <ul>
                <li>Our team will review your company profile and project needs</li>
                <li>We'll schedule a brief onboarding call to understand your requirements</li>
                <li>You'll get access to post RFQs and receive proposals from qualified freelancers</li>
                <li>We'll provide guidance on creating effective project listings</li>
              </ul>
            </div>

            <button onClick={props.onNavigateToHome} className="btn-home">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Back to Home
            </button>
          </div>
        </div>

        <Footer {...props} />
      </div>
    );
  }

  return (
    <div className="business-contact-page">
      <Navigation {...props} />

      <div className="business-contact-container">
        <div className="business-header">
          <div className="header-badge">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2"/>
              <path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16"/>
            </svg>
            <span>BUSINESS ONBOARDING</span>
          </div>

          <h1>Partner With Global Expedyte</h1>
          
          <p className="header-description">
            Contact us to onboard your business and start posting projects to our network of verified freelancers.
          </p>
        </div>

        <div className="form-wrapper">
          <div className="form-card">
            <h2>Request Business Access</h2>
            <p className="form-intro">
              Fill out the form below and our team will contact you to set up your business account.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Company Name *</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleChange}
                  placeholder="Your company name"
                  required
                />
              </div>

              <div className="form-group">
                <label>Contact Person *</label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  placeholder="Full name"
                  required
                />
              </div>

              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your@company.com"
                  required
                />
              </div>

              <div className="form-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="+27 12 345 6789"
                  required
                />
              </div>

              <div className="form-group">
                <label>Industry *</label>
                <select
                  name="industry"
                  value={formData.industry}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select your industry...</option>
                  <option value="technology">Technology & IT</option>
                  <option value="finance">Finance & Banking</option>
                  <option value="retail">Retail & E-commerce</option>
                  <option value="healthcare">Healthcare</option>
                  <option value="education">Education</option>
                  <option value="manufacturing">Manufacturing</option>
                  <option value="marketing">Marketing & Advertising</option>
                  <option value="consulting">Consulting</option>
                  <option value="real-estate">Real Estate</option>
                  <option value="other">Other</option>
                </select>
              </div>

              <div className="form-group">
                <label>Type of Projects You Need *</label>
                <select
                  name="projectNeeds"
                  value={formData.projectNeeds}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select project type...</option>
                  <option value="web-development">Web Development</option>
                  <option value="graphic-design">Graphic Design</option>
                  <option value="content-writing">Content Writing</option>
                  <option value="digital-marketing">Digital Marketing</option>
                  <option value="software-development">Software Development</option>
                  <option value="data-entry">Data Entry & Admin</option>
                  <option value="accounting">Accounting & Bookkeeping</option>
                  <option value="legal">Legal Services</option>
                  <option value="multiple">Multiple Categories</option>
                </select>
              </div>

              <div className="form-group">
                <label>Additional Information</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Tell us about your project needs, budget range, timeline, or any specific requirements..."
                ></textarea>
              </div>

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? (
                  <>
                    <div className="spinner"></div>
                    Submitting...
                  </>
                ) : (
                  <>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M22 2L11 13"/>
                      <path d="M22 2L15 22L11 13L2 9L22 2Z"/>
                    </svg>
                    Request Access
                  </>
                )}
              </button>

              <p className="form-note">
                By submitting this form, you agree to be contacted by our business development team.
              </p>
            </form>
          </div>
        </div>
      </div>

      <Footer {...props} />
    </div>
  );
};

export default BusinessContact;